/**
 * Mark a string constant as being a translation label reference
 *
 * @param labelName Name of the label being referenced. Must be a string constant - no computed strings or string concatenations!
 * @returns The label name passed in
 */
export function asLabel(labelName: string): string {
	return labelName;
}
